module.exports = __webpack_public_path__ + "img/employee-data-cards.4af6a981.svg";